import {
  COLOUR_AZURE,
  COLOUR_BLUE,
  COLOUR_CYAN,
  COLOUR_GOLD,
  COLOUR_GREEN,
  COLOUR_GREY,
  COLOUR_LIME,
  COLOUR_MAGENTA,
  COLOUR_ORANGE,
  COLOUR_PURPLE,
  COLOUR_RED,
  COLOUR_VOLCANO,
} from 'approot/shared/colour/colour.constants';

export const BACKGROUND_COLOURS = [
  COLOUR_GREY,
  COLOUR_MAGENTA,
  COLOUR_RED,
  COLOUR_VOLCANO,
  COLOUR_ORANGE,
  COLOUR_GOLD,
  COLOUR_LIME,
  COLOUR_GREEN,
  COLOUR_CYAN,
  COLOUR_BLUE,
  COLOUR_AZURE,
  COLOUR_PURPLE,
];

export const IMAGE_OPTION = 'image';
export const COLOUR_OPTION = 'colour';
